// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input:focus:checked ~ .label[data-v-6300c6ba]::before,\n.input:focus-visible ~ .label[data-v-6300c6ba]::before {\n  background-color: var(--magic-primary, #6c5dd3);\n}\n\n.input:hover ~ .label[data-v-6300c6ba]::before {\n  background-color: var(--magic-primary, #6c5dd3);\n}", ""]);
// Exports
module.exports = exports;
